export const decimalFormat = new Intl.NumberFormat('da-DK', {
  style: 'decimal',
  maximumFractionDigits: 0,
});
